// extracted by mini-css-extract-plugin
export default {"draft":"PrismicDraftContainer-module_draft__bebuj"};